module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "definition-node-drop-zone level-0",
    attrs: {
      "draggable": false
    },
    on: {
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler
    }
  }, [_vm._v("\n  Drop at end\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04e4c87d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/targetDefinition/components/targetDefinitionStatement/DefinitionNodeDropZone.vue
// module id = 1798
// module chunks = 0